import { render, staticRenderFns } from "./StockCount.vue?vue&type=template&id=195b88d1&scoped=true&"
import script from "./StockCount.vue?vue&type=script&lang=js&"
export * from "./StockCount.vue?vue&type=script&lang=js&"
import style0 from "./StockCount.vue?vue&type=style&index=0&id=195b88d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b88d1",
  null
  
)

export default component.exports